import {
  GET_MAIN_CATEGORY_REQUEST,
  GET_MAIN_CATEGORY_SUCCESS,
  GET_MAIN_CATEGORY_FAILURE,
} from "../../../Utils/Constant";

const initialState = {
  data: null,
  loading: false,
  error: null,
};
export const mainCategoryReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_MAIN_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case GET_MAIN_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case GET_MAIN_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
